import React from "react";
import PropTypes from "prop-types";
import Slide from "react-reveal/Slide";
import { Col, Row } from "reactstrap";

export default class Credit extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    image: PropTypes.any,
    imageLink: PropTypes.string,
    alt: PropTypes.string,
    desc: PropTypes.element
  };

  render() {
    const { title, link, image, imageLink, alt, desc } = this.props;

    return (
      <Slide bottom big cascade>
        <Row className="justify-content-center">
          <Col lg={6} md={3}>
            <h3>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {title}
              </a>
            </h3>

            {imageLink ? (
              <a href={imageLink} target="_blank" rel="noopener noreferrer">
                <img src={image} alt={alt} width="100%" />
              </a>
            ) : (
              <img src={image} alt={alt} width="100%" />
            )}

            {desc}
          </Col>
        </Row>
      </Slide>
    );
  }
}
